import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import flag from "../../assets/images/UAE flag.jpeg";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";

import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { getCountryCallingCode, getExampleNumber, getExtPrefix, AsYouType } from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';
import AuthGuard from "../../components/AuthGuard";
import { useTranslation } from "react-i18next";
const CompanyInfoForm = () => {
  const { t, i18n } = useTranslation();
        const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [emirates, setEmirates] = useState(false);

  const [formData, setFormData] = useState({
    about: "",
    category: null,
    customCategory: "",
    email: "",
    password: "",
    location: "",
    phone: "",
    secondary_phone: "",
    website: "",
    reg_date: "",
    check_validation: "",
    sector: "",
    customSector: "",
    social_accounts: {
      instagram: "",
      tiktok: "",
      twitter: "",
    },
    trade_license_no: null,
    trn: null,
    trade_license_file: null,
    vat_certificate_file: null,
  });

  // const persist = useCallback(
  //   (next) => localStorage.setItem("companyInfoForm", JSON.stringify(next)),
  //   []
  // );

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [selectedType, setSelectedType] = useState("");

  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      const file = files[0];
      const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg', 'application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        toast.error("Invalid file type. Supported formats: JPG, JPEG, PNG, WEBP, PDF");
        e.target.value = "";
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size exceeds 5MB limit.");
        e.target.value = "";
        return;
      }

      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await ApiService.request({
          method: "GET",
          url: "/company/getCategories",
        });

        console.log("API Response:", res.data);

        const categoriesArray = res.data.data.categories;
        if (Array.isArray(categoriesArray)) {
          const formattedOptions = categoriesArray.map((cat) => ({
            value: cat._id,
            label: i18n.language === "ar" ? cat.title_ar : cat.title,
          }));
  
          // Append the 'Other' option
          formattedOptions.push({ value: "other", label: i18n.language === "ar" ? "اخرى" : "Other" });
          setCategoryOptions(formattedOptions);
        } else {
          toast.error("Categories not in expected format");
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
        toast.error("Failed to load categories");
      }
    })();
  }, []);

  useEffect(() => {
    if (!formData.category) {
      setSubCategoryOptions([]);
      return;
    }
    (async () => {
      try {
        const res = await ApiService.request({
          method: "GET",
          url: `/company/getSubCategories?category_id=${formData.category}`,
        });
        const subs = res.data.data.categories;
          setSubCategoryOptions(
            Array.isArray(subs)
              ? subs.map((s) => ({
                  value: s._id,
                  label: i18n.language === "ar" ? s.title_ar || s.title : s.title,
                }))
              : []
          );
      } catch (e) {
        console.log(e.message);
        toast.error("Failed to load sub‑categories");
      }
    })();
  }, [formData.category]);

  const getEmirates = async () => {
    try {
      const res = await ApiService.request({
        method: "GET",
        url: `/getEmirates`,
      });
      setEmirates(res?.data?.data?.emirates);
    } catch (e) {
      console.log(e.message);
    }
  };
  useEffect(() => {
    getEmirates();
  }, []);

  // const handleTextChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => {
  //     const next = { ...prev, [name]: value };
  //     // persist(next);
  //     return next;
  //   });
  //   if (errors[name]) {
  //     setErrors((p) => ({ ...p, [name]: null }));
  //   }
  //   if (['password', 'location'].includes(name)) {
  //     if (!value.trim()) {
  //       setErrors(prev => ({ ...prev, [name]: "Required" }));
  //     }
  //   }

  // };

  const handleTextChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const next = { ...prev };

      // Check if the field belongs to social_accounts
      if (name.startsWith("social_accounts[")) {
        const key = name.match(/\[(.*?)\]/)[1]; // Extract 'instagram', 'twitter', etc.
        next.social_accounts = {
          ...prev.social_accounts,
          [key]: value,
        };
      } else {
        next[name] = value;
      }

      return next;
    });

    // Clear error if exists
    if (errors[name]) {
      setErrors((p) => ({ ...p, [name]: null }));
    }

    // Validation for specific fields
    if (["password", "location"].includes(name)) {
      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, [name]: "Required" }));
      }
    }
  };

  // const handlePhoneNumberChange = (e) => {
  //   const { name, value } = e.target;

  //   // Phone number-specific validation
  //   if (name === "phone" || name === "secondary_phone") {
  //     // Remove non-digit characters
  //     let digitsOnly = value.replace(/\D/g, "");

  //     // Restrict to max 10 digits
  //     if (digitsOnly.length > 10) {
  //       digitsOnly = digitsOnly.slice(0, 10);
  //     }

  //     // Allow only if it starts with '5' or '05'
  //     if (!/^5\d{0,9}$/.test(digitsOnly) && !/^05\d{0,8}$/.test(digitsOnly)) {
  //       return; // Do not update state if not valid starting pattern
  //     }

  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: digitsOnly,
  //     }));

  //     if (errors[name]) {
  //       setErrors((prev) => ({ ...prev, [name]: null }));
  //     }

  //     return;
  //   }

  //   // Generic handling for other fields
  //   setFormData((prev) => {
  //     const next = { ...prev, [name]: value };
  //     return next;
  //   });

  //   if (errors[name]) {
  //     setErrors((p) => ({ ...p, [name]: null }));
  //   }
  // };

  // In your form component
  const handlePhoneNumberChange = (e) => {
    const { name, value, countryCode } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value,
      [`${name}_countryCode`]: countryCode // Store country code separately
    }));

    // Clear error when user types
    setErrors(prev => ({ ...prev, [name]: null }));
  };




  const handleWebsiteChange = (e) => {
    const { value } = e.target;

    setFormData({ ...formData, website: value });

    if (!isValidWebsite(value)) {
      setErrors({
        ...errors,
        website: "Please enter a valid website URL (e.g., example.com)",
      });
    } else {
      const newErrors = { ...errors };
      delete newErrors.website;
      setErrors(newErrors);
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "Required" }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  // const handleRegYearChange = (e) => {
  //   const { name, value } = e.target;

  //   // Remove non-digit characters and limit to 4 digits
  //   let cleanedValue = value.replace(/\D/g, "").slice(0, 4);

  //   const currentYear = new Date().getFullYear();
  //   const minYear = 1900;

  //   let errorMessage = null;

  //   if (cleanedValue.length === 4) {
  //     const year = parseInt(cleanedValue, 10);

  //     if (year > currentYear) {
  //       errorMessage = `Year cannot be in the future (max ${currentYear})`;
  //     } else if (year < minYear) {
  //       errorMessage = `Year must be after ${minYear}`;
  //     }
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: cleanedValue,
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: errorMessage,
  //   }));
  // };
  // const handleRegYearChange = (date) => {
  //   const year = date?.getFullYear?.() || "";
  //   const currentYear = new Date().getFullYear();
  //   const minYear = 1900;

  //   let errorMessage = null;

  //   if (year) {
  //     if (year > currentYear) {
  //       errorMessage = `Year cannot be in the future (max ${currentYear})`;
  //     } else if (year < minYear) {
  //       errorMessage = `Year must be after ${minYear}`;
  //     }
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     reg_year: date,
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     reg_year: errorMessage,
  //   }));
  // };
  const handleRegYearChange = (date) => {
    const currentDate = new Date();
    let errorMessage = null;

    if (date) {
      if (date < currentDate.setHours(0, 0, 0, 0)) {
        errorMessage = "Expiry date must be in the future.";
      }
    }

    setFormData((prev) => ({
      ...prev,
      reg_date: date,
    }));

    setErrors((prev) => ({
      ...prev,
      reg_date: errorMessage,
    }));
  };

  const isValidWebsite = (url) => {
    const pattern =
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/.*)?$/;
    return pattern.test(url);
  };

  // const handleSelectChange = (name, selectedOptions) => {
  //   setFormData((prev) => {
  //     let next;

  //     if (name === "category") {
  //       next = {
  //         ...prev,
  //         category: selectedOptions?.value || "",
  //         subCategory: [], // Reset subcategory if category changes
  //       };
  //     } else if (name === "subCategory") {
  //       next = {
  //         ...prev,
  //         subCategory: Array.isArray(selectedOptions)
  //           ? selectedOptions.map((o) => o.value)
  //           : [],
  //       };
  //     }

  //     return next;
  //   });

  //   // Clear validation error if fixed
  //   if (errors[name]) {
  //     setErrors((prev) => ({ ...prev, [name]: null }));
  //   }
  //   if (!formData.subCategory || formData.subCategory.length === 0) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       subCategory: "Please select at least one subcategory.",
  //     }));
  //     return;
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (name, selectedOptions) => {
    setFormData((prev) => {
      let next;

      if (name === "category") {
        next = {
          ...prev,
          category: selectedOptions?.value || "",
          subCategory: [], // Reset subcategory if category changes
        };
      } else if (name === "subCategory") {
        next = {
          ...prev,
          subCategory: Array.isArray(selectedOptions)
            ? selectedOptions.map((o) => o.value)
            : [],
        };
      }

      if (errors[name]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: null,
        }));
      }

      if (
        name === "subCategory" &&
        (!next.subCategory || next.subCategory.length === 0)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          subCategory: "Please select at least one subcategory.",
        }));
      }

      return next;
    });
  };

  // const handleSelectChange = (name, selectedOptions) => {
  //   setFormData((prev) => {
  //     let next = { ...prev };
  
  //     if (name === "category") {
  //       next.category = selectedOptions?.value || "";
  //       next.categoryLabel = selectedOptions?.label || ""; // Store label
  //       next.subCategory = []; // Reset subcategory
  //     } else if (name === "subCategory") {
  //       next.subCategory = Array.isArray(selectedOptions)
  //         ? selectedOptions.map((o) => o.value)
  //         : [];
  //     }
  
  //     if (errors[name]) {
  //       setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  //     }
  
  //     if (name === "subCategory" && (!next.subCategory || next.subCategory.length === 0)) {
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         subCategory: "Please select at least one subcategory.",
  //       }));
  //     }
  
  //     return next;
  //   });
  // };
  
  const handleContinue = async () => {
    const required = [
      "category",
      "email",
      "password",
      "location",
      "phone",
      "sector",
    ];
    const errs = {};
    required.forEach((k) => {
      if (!formData[k]) errs[k] = t("t_d_text100");
    });
    if (formData.sector === "other" && !formData.customSector) {
      errs.customSector = t("t_d_text100");
    }
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    try {
      setIsLoader(true);
      const formPayload = new FormData();
      const stripLeadingZero = (num) => num?.startsWith('0') ? num.slice(1) : num;

      const payload = {
        company_name: localStorage.getItem("companyName") || "",
        about: formData.about,
        category_id:
          formData.category === "other"
            ? formData.customCategory
            : formData.category,
        email: formData.email,
        password: formData.password,
        location: formData.location,
        phone: (formData.phone_countryCode || "+971") + stripLeadingZero(formData.phone),
        secondary_phone:
          (formData.secondary_phone_countryCode || "+971") +
          stripLeadingZero(formData.secondary_phone),
        website: formData.website,
        license_no: formData.license_no,
        reg_date: formData.reg_date,
        check_validation: true,
        sector:
          formData.sector === "other"
            ? formData.customSector
            : formData.sector,
        trn: formData.trn,
        trade_license_no: formData.trade_license_no,
      };
      formPayload.append(
        "company_name",
        localStorage.getItem("companyName") || ""
      );
      formPayload.append("about", formData.about || "");
      formPayload.append("category_id",   formData.category === "other" 
        ? formData.customCategory 
        : formData.category);
      formPayload.append("email", formData.email);
      formPayload.append("password", formData.password);
      formPayload.append("location", formData.location);
      formPayload.append("phone", formData.phone_countryCode + stripLeadingZero(formData.phone));
      if (formData.secondary_phone) {
        formPayload.append(
          "secondary_phone",
          formData.secondary_phone_countryCode + stripLeadingZero(formData.secondary_phone)
        );
      }
      formPayload.append("website", formData.website);
      formPayload.append("check_validation", true);
      formPayload.append(
        "sector",
        formData.sector === "other" ? formData.customSector : formData.sector
      );
      formPayload.append(
        "social_accounts[instagram]",
        formData.social_accounts.instagram || ""
      );
      formPayload.append(
        "social_accounts[tiktok]",
        formData.social_accounts.tiktok || ""
      );
      formPayload.append(
        "social_accounts[twitter]",
        formData.social_accounts.twitter || ""
      );

      const res = await ApiService.request({
        method: "POST",
        url: "/company/register",
        data: formPayload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const data = res.data;
      console.log(data);

      if (data.status) {
        const company_id = data.data?.company_id || data.data?._id;
        if (company_id) {
          localStorage.setItem("company_id", company_id);
        }
        // toast.success(res.data.message || "Saved!");
        localStorage.setItem("companyInfo", JSON.stringify(payload));
        localStorage.setItem("phone", payload.phone);
        localStorage.setItem("secondary_phone", payload.secondary_phone);
        navigate("/company/upload-documents");
      } else {
        toast.error(res.data.message || "Server returned an error.");
      }
    } catch {
      toast.error("Registration failed, please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <AuthGuard>
    <div className="inter-font sofia-font main-bg min-vh-100 d-flex flex-column align-items-center pt-4">
      <Container fluid className="inter-font position-absolute top-0 mt-3">
        <Row className="inter-font align-items-center">
          <Link
            to={"/"}
            xs={12}
            md={1}
            className="col inter-font text-center text-md-start mb-3 mb-md-0 cursor-pointer"
          >
            <img src={logo} alt="Logo" style={{ height: "50px" }} />
          </Link>
         <Col xs={12} md={11} className="inter-font text-center">
  <div className="inter-font d-flex flex-md-row align-items-center justify-content-center gap-2">
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>1</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("select_company")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step active>2</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("add_information")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>3</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("upload_documents")}
      </span>
    </div>
  </div>
</Col>
          
        </Row>
      </Container>

      <div
        className="inter-font bg-white p-4 mb-5 shadow rounded-4 company-registration-form"
        style={{ width: "90%", maxWidth: "677px", marginTop: "100px" }}
      >
        <h4 className="inter-font fw-bold inter-font">
          {t("c_reg_form_title")}
        </h4>
        <p className="inter-font fw-lighter text-muted inter-font">
          {t("c_reg_form_dec")}
        </p>

       <h4 className="inter-font fw-bolder mt-5" style={{ textAlign: isRTL ? "right" : "left" }}>
  {t("new_text_27")}
</h4>
<Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
  {t("c_reg_form_s1")}
</Form.Label>

<Form.Group className="inter-font mb-3">
  <Form.Control
    as="textarea"
    rows={4}
    placeholder={t("new_text_38")}
    value={formData.about}
    name="about"
    onChange={handleTextChange}
    isInvalid={!!errors.about}
    className="inter-font inp-bg text-size p-2 rounded-3 inp-login sofia-font"
    style={{
      height: "7.5em",
      overflowY: "auto",
      resize: "none",
      lineHeight: "1.5em",
      textAlign: isRTL ? "right" : "left",
      direction: "ltr"
    }}
  />
  <Form.Control.Feedback type="invalid" style={{ textAlign: isRTL ? "right" : "left" }}>
    {errors.about}
  </Form.Control.Feedback>
</Form.Group>

<Row>
  <Col md={6} className="inter-font mt-3">
    <Form.Group>
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("new_text_25")} <span className="text-danger">*</span>
      </Form.Label>

      <Select
        options={categoryOptions
          .slice()
          .sort((a, b) => a.label.localeCompare(b.label))}
        value={
          categoryOptions.find((o) => o.value === formData.category) || null
        }
        onChange={(opt) => {
          if (opt?.value === "other") {
            setFormData((prev) => ({ ...prev, category: "other", customCategory: "" }));
          } else {
            setFormData((prev) => ({ ...prev, category: opt?.value, customCategory: "" }));
          }
        }}
        placeholder={t("select_category")}
      />

      {formData.category === "other" && (
        <Form.Control
          type="text"
          placeholder={t("enter_category")}
          className="mt-2"
          value={formData.customCategory || ""}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              customCategory: e.target.value
            }))
          }
          style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        />
      )}

      {errors.category && (
        <div className="inter-font text-danger small mt-1" style={{ textAlign: isRTL ? "right" : "left" }}>
          {errors.category}
        </div>
      )}
    </Form.Group>
  </Col>

  <Col md={6} className="inter-font mt-3">
    <Form.Group className="mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("c_ff_text26")} <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        name="sector"
        value={formData.sector || ""}
        onChange={(e) => {
          const { value } = e.target;
          setFormData((prev) => ({
            ...prev,
            sector: value,
            customSector: value === "other" ? prev.customSector : "",
          }));
          if (errors.sector) {
            setErrors((prev) => ({ ...prev, sector: null }));
          }
          if (errors.customSector) {
            setErrors((prev) => ({ ...prev, customSector: null }));
          }
        }}
        required
        className={formData.sector === "" ? "placeholder-select" : ""}
        style={{ textAlign: isRTL ? "right" : "left" }}
      >
        <option value="">{t("c_ff_text27")}</option>
        <option value="Government">{t("c_ff_text28")}</option>
        <option value="Private">{t("c_ff_text29")}</option>
        <option value="Semi-Government">{t("sector_semi_government")}</option>
        <option value="Freelance">{t("sector_freelance")}</option>
        <option value="other">{t("sector_other")}</option>
      </Form.Select>
      {formData.sector === "other" && (
        <Form.Control
          type="text"
          placeholder={t("enter_sector")}
          className="mt-2"
          value={formData.customSector || ""}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              customSector: e.target.value,
            }))
          }
          style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        />
      )}
      {errors.sector && (
        <div
          className="inter-font text-danger small mt-1"
          style={{ textAlign: isRTL ? "right" : "left" }}
        >
          {errors.sector}
        </div>
      )}
      {errors.customSector && formData.sector === "other" && (
        <div
          className="inter-font text-danger small mt-1"
          style={{ textAlign: isRTL ? "right" : "left" }}
        >
          {errors.customSector}
        </div>
      )}
    </Form.Group>
  </Col>
        </Row>
<h4 className="inter-font fw-bolder mt-4" style={{ textAlign: isRTL ? "right" : "left" }}>
  {t("c_reg_form_s2")}
</h4>
<Row>
  <Col md={6}>
    <Form.Group className="inter-font mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("c_ff_text30")} <span className="text-danger">*</span>
      </Form.Label>
      <Form.Control
        type="email"
        placeholder={t("c_ff_text3")}
        value={formData.email}
        name="email"
        onChange={handleTextChange}
        isInvalid={!!errors.email}
        className="inter-font inp-bg sofia-font inp-login"
        style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        onBlur={() => {
          if (!formData.email) {
            setErrors((prev) => ({
              ...prev,
              email: t("email_required"),
            }));
          } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
          ) {
            setErrors((prev) => ({
              ...prev,
              email: t("email_invalid"),
            }));
          }
        }}
      />
      <Form.Control.Feedback type="invalid" style={{ textAlign: isRTL ? "right" : "left" }}>
        {errors.email}
      </Form.Control.Feedback>
    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="inter-font mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("c_ff_text2")} <span className="text-danger">*</span>
      </Form.Label>
      <div className="position-relative">
        <Form.Control
          type={showPassword ? "text" : "password"}
          placeholder={t("new_text_17")}
          value={formData.password}
          name="password"
          onChange={handleTextChange}
          onBlur={handleBlur}
          isInvalid={!!errors.password}
          className="inter-font inp-bg sofia-font inp-login"
          style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          className="position-absolute"
          style={{
            top: "50%",
            [isRTL ? "left" : "right"]: "15px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "16px",
            color: "#888",
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>
      <Form.Control.Feedback type="invalid" style={{ textAlign: isRTL ? "right" : "left" }}>
        {errors.password}
      </Form.Control.Feedback>
    </Form.Group>
  </Col>
</Row>
<Form.Group className="inter-font mb-3">
  <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
    {t("c_ff_text32")} <span className="text-danger">*</span>
  </Form.Label>

  <Form.Select
    name="location"
    value={formData.location}
    onChange={handleTextChange}
    onBlur={handleBlur}
    isInvalid={!!errors.location}
    className={`inter-font inp-bg sofia-font inp-login ${
      formData.sector === "" ? "placeholder-select" : ""
    }`}
    style={{ textAlign: isRTL ? "right" : "left" }}
  >
    <option value="">{t("c_ff_text33")}</option>
    {emirates.length > 0 &&
      emirates?.map((emirate) => (
        <option key={emirate} value={emirate}>
          {emirate}
        </option>
      ))}
  </Form.Select>

  <Form.Control.Feedback type="invalid" style={{ textAlign: isRTL ? "right" : "left" }}>
    {errors.location}
  </Form.Control.Feedback>
</Form.Group>

<Row>
  <Col md={6} className="mb-3">
    <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
      {t("c_ff_text41")} <span className="text-danger">*</span>
    </Form.Label>
                    <InputGroupWithFlag
  placeholder="50 123 4567"
  name="phone"
  value={formData.phone}
  onChange={handlePhoneNumberChange}
  isInvalid={!!errors.phone}
/>
  </Col>
  <Col md={6}>
    <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
      {t("new_text_40")}
    </Form.Label>
             <InputGroupWithFlag
  placeholder="2 123 4567"
  name="secondary_phone"
  value={formData.secondary_phone}
  onChange={handlePhoneNumberChange}
  isInvalid={!!errors.secondary_phone}
/>
  </Col>
</Row>

<Form.Group className="inter-font mb-3">
  <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
    {t("c_ff_text45")}
  </Form.Label>
  <Form.Control
    type="url"
    placeholder={t("c_ff_text46")}
    name="website"
    value={formData.website}
    onChange={handleWebsiteChange}
    onBlur={(e) => {
      if (!isValidWebsite(e.target.value)) {
        setErrors({
          ...errors,
          website: t("website_invalid"),
        });
      }
    }}
    isInvalid={!!errors.website}
    className="inter-font inp-bg sofia-font inp-login"
    style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
  />
  <Form.Control.Feedback type="invalid" style={{ textAlign: isRTL ? "right" : "left" }}>
    {errors.website}
  </Form.Control.Feedback>
</Form.Group>

<Row className="mt-4">
  <Col md={6}>
    <Form.Group className="inter-font mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("instagram")}
      </Form.Label>
      <Form.Control
        type="text"
        placeholder={t("c_ff_text52")}
        name="social_accounts[instagram]"
        value={formData.social_accounts.instagram}
        onChange={handleTextChange}
        className="inter-font inp-bg sofia-font inp-login"
        style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
      />
    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="inter-font mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("twitter")}
      </Form.Label>
      <Form.Control
        type="text"
        placeholder={t("c_ff_text54")}
        name="social_accounts[twitter]"
        value={formData.social_accounts.twitter}
        onChange={handleTextChange}
        className="inter-font inp-bg sofia-font inp-login"
        style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
      />
    </Form.Group>
  </Col>
</Row>

<Row>
  <Col md={6}>
    <Form.Group className="inter-font mb-3">
      <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
        {t("tiktok")}
      </Form.Label>
      <Form.Control
        type="text"
        placeholder={t("c_ff_text56")}
        name="social_accounts[tiktok]"
        value={formData.social_accounts.tiktok}
        onChange={handleTextChange}
        className="inter-font inp-bg sofia-font inp-login"
        style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
      />
    </Form.Group>
  </Col>
</Row>

<div className="inter-font text-center mt-4">
  <Button
    className="inter-font px-5 btn btn-base border-0"
    onClick={handleContinue}
    disabled={isLoader}
    style={{
      backgroundColor: "#E26A52",
      color: "#fff"
    }}
  >
    {isLoader ? t("c_ff_text59") : t("c_continue")}
  </Button>
</div>
      </div>
    </div>
    </AuthGuard>
  );
};

const Step = ({ children, active }) => (
  <div
    className={`inter-font rounded-circle d-flex num-circle align-items-center justify-content-center fw-bold ${
      active ? "bg-dark text-white" : "bg-light text-muted"
    }`}
    style={{ width: "30px", height: "30px", fontSize: "14px" }}
  >
    {children}
  </div>
);

const Arrow = () => <span className="inter-font text-muted">→</span>;








const InputGroupWithFlag = ({
  placeholder,
  name,
  value,
  onChange,
  isInvalid,
}) => {
  const handleNumberChange = (e) => {
    // Remove all non-numeric characters
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    onChange({
      target: {
        name: name,
        value: numericValue,
      },
    });
  };

  return (
    <div
      className={ `inter-font d-flex form-control align-items-center border rounded ps-2 ${
        isInvalid ? "border-danger" : ""
      }`}
      style={{ direction: "ltr" }}
    >
      <img
        src={flag}
        alt="UAE"
        style={{ width: "25px", height: "18px", marginRight: "6px" }}
      />
      <span className="inter-font text-muted pe-2 inter-font">(+971)</span>
      <Form.Control
        type="text"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleNumberChange}
        isInvalid={isInvalid}
        maxLength={value?.startsWith("0") ? 10 : 9}
        className="inter-font border-0 ps-1 sofia-font w-100"
        style={{
          boxShadow: "none",
          height: "33px",
        }}
      />
    </div>
  );
};







export default CompanyInfoForm;
